// // src/app/services/chatbot.service.ts
// import { Injectable } from '@angular/core';
// import { HttpClient, HttpErrorResponse } from '@angular/common/http';
// import { Observable, throwError, BehaviorSubject } from 'rxjs';
// import { catchError, retry, timeout } from 'rxjs/operators';
// import { ChatResponse, HealthStatus } from '../core/interfaces/message.interface'

// @Injectable({
//   providedIn: 'root'
// })
// export class ChatbotService {

//   private readonly apiUrl = 'http://localhost:3000/api';
//   private connectionStatus = new BehaviorSubject<boolean>(false);
  
//   // Observable for connection status
//   public connectionStatus$ = this.connectionStatus.asObservable();

//   constructor(private http: HttpClient) {
//     this.initializeConnection();
//   }

//   /**
//    * Initialize connection check
//    */
//   private async initializeConnection(): Promise<void> {
//     try {
//       await this.checkHealth().toPromise();
//       this.connectionStatus.next(true);
//     } catch (error) {
//       this.connectionStatus.next(false);
//       console.warn('Initial connection check failed:', error);
//     }
//   }

//   /**
//    * Send message to chatbot
//    */
//   sendMessage(query: string): Observable<ChatResponse> {
//     const payload = { query: query.trim() };
    
//     return this.http.post<ChatResponse>(`${this.apiUrl}/chat`, payload)
//       .pipe(
//         timeout(30000), // 30 second timeout
//         retry(1), // Retry once on failure
//         catchError(this.handleError)
//       );
//   }

//   /**
//    * Check server health
//    */
//   checkHealth(): Observable<HealthStatus> {
//     return this.http.get<HealthStatus>(`${this.apiUrl}/health`)
//       .pipe(
//         timeout(10000), // 10 second timeout
//         catchError(this.handleError)
//       );
//   }

//   /**
//    * Periodically check connection status
//    */
//   startConnectionMonitoring(intervalMs: number = 60000): void {
//     setInterval(async () => {
//       try {
//         await this.checkHealth().toPromise();
//         if (!this.connectionStatus.value) {
//           this.connectionStatus.next(true);
//         }
//       } catch (error) {
//         if (this.connectionStatus.value) {
//           this.connectionStatus.next(false);
//         }
//       }
//     }, intervalMs);
//   }

//   /**
//    * Get current connection status
//    */
//   isConnected(): boolean {
//     return this.connectionStatus.value;
//   }

//   /**
//    * Handle HTTP errors
//    */
//   private handleError = (error: HttpErrorResponse): Observable<never> => {
//     let errorMessage = 'An unknown error occurred';
    
//     if (error.error instanceof ErrorEvent) {
//       // Client-side error
//       errorMessage = `Client Error: ${error.error.message}`;
//     } else {
//       // Server-side error
//       switch (error.status) {
//         case 0:
//           errorMessage = 'Unable to connect to server. Please check your connection.';
//           break;
//         case 400:
//           errorMessage = 'Invalid request. Please check your input.';
//           break;
//         case 404:
//           errorMessage = 'Service not found. Please try again later.';
//           break;
//         case 500:
//           errorMessage = 'Server error. Please try again later.';
//           break;
//         case 408:
//           errorMessage = 'Request timeout. Please try again.';
//           break;
//         default:
//           errorMessage = `Server Error: ${error.status} - ${error.message}`;
//       }
//     }
    
//     console.error('ChatbotService Error:', errorMessage, error);
//     return throwError(errorMessage);
//   };
// }
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Message, ChatResponse, ChatSession } from '../services/chatbot.module';
import { environment } from '../../environments/environment';



@Injectable({
  providedIn: 'root'
})
export class ChatService {
   private readonly restApiURL: string;
 // private readonly baseUrl = 'http://localhost:3000/api/chat';
  
  private messagesSubject = new BehaviorSubject<Message[]>([]);
  public messages$ = this.messagesSubject.asObservable();
  
  private sessionId: string = '';
  private isTypingSubject = new BehaviorSubject<boolean>(false);
  public isTyping$ = this.isTypingSubject.asObservable();
  columns: string[] = [];
  getUserName: string | null = sessionStorage.getItem("username");
  speackerName:string = this.getUserName?.includes(',') ? this.getUserName.substring(this.getUserName.indexOf(',') + 1).trim(): this.getUserName || '';

  constructor(private http: HttpClient) {
    this.initializeSession();
     //this.restApiURL = environment.apiHost+'/api/chat';
     this.restApiURL = 'http://localhost:4000/api/v1/chat';
  }


  private initializeSession(): void {
    this.sessionId = this.generateSessionId();
    this.loadStoredMessages();
  }

  private generateSessionId(): string {
    return 'session_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  sendMessage(content: string, userId?: string): Observable<ChatResponse> {
    const message: Message = {
      id: this.generateMessageId(),
      type:'user',
      content: content.trim(),
      name :this.speackerName,

      timestamp: new Date()
    };

    // Add user message immediately
    this.addMessage(message);
    this.setTyping(true);

    const payload = {
      message: content,
      sessionId: this.sessionId,
      userId: this.speackerName
    };

    return this.http.post<ChatResponse>(`${this.restApiURL}`, payload)
      .pipe(
        retry(2),
        catchError(this.handleError.bind(this))
      );
  }
addBotResponse(response: ChatResponse): void {
  const {data, response: replyText, timestamp } = response;

  if (data?.length === 0  || !response.success) {
    const botMessage: Message = {
      id: this.generateMessageId(),
      type: 'bot',
      name: 'Bot',
      content: replyText || 'No data found for your query.',
      timestamp: new Date(),
    };
    this.addMessage(botMessage);
    this.setTyping(false);
    return;
  }

  const columns = Object.keys(data?.[0] || {});

  // Build output: each column on a separate line with its values
  const messageContent = columns.map(col => {
    const values = data!.map(row => row[col]).join(', ');
    return `${col}:\n${values}`;
  }).join('\n\n');  // Changed from '\n' to '\n\n' for better separation

  const botMessage: Message = {
    id: this.generateMessageId(),
    type: 'bot',
    name: 'Bot',
    content: messageContent.trim(),
    timestamp: new Date(),
  };

  this.addMessage(botMessage);
  this.setTyping(false);
}


  private addMessage(message: Message): void {
    const currentMessages = this.messagesSubject.value;
    const updatedMessages = [...currentMessages, message];
    this.messagesSubject.next(updatedMessages);
    this.saveMessagesToStorage(updatedMessages);
  }

  getConversationHistory(): Observable<ChatSession> {
    return this.http.get<ChatSession>(`${this.restApiURL}/history/${this.sessionId}`)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  clearConversation(): Observable<any> {
    return this.http.delete(`${this.restApiURL}/clear/${this.sessionId}`)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }

  clearLocalConversation(): void {
    this.messagesSubject.next([]);
    this.clearStoredMessages();
    this.sessionId = this.generateSessionId();
  }

  private setTyping(isTyping: boolean): void {
    this.isTypingSubject.next(isTyping);
  }

  private generateMessageId(): string {
    return 'msg_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  private saveMessagesToStorage(messages: Message[]): void {
    try {
      const sessionData = {
        sessionId: this.sessionId,
        messages,
        lastActivity: new Date()
      };
      // Note: In Claude.ai environment, we'd use a service or state management
      // instead of localStorage
      console.log('Saving session data:', sessionData);
    } catch (error) {
      console.warn('Could not save messages to storage:', error);
    }
  }

  private loadStoredMessages(): void {
    try {
      // In a real app, this would load from localStorage or a service
      console.log('Loading stored messages for session:', this.sessionId);
    } catch (error) {
      console.warn('Could not load stored messages:', error);
    }
  }

  private clearStoredMessages(): void {
    try {
      // In a real app, this would clear localStorage
      console.log('Clearing stored messages');
    } catch (error) {
      console.warn('Could not clear stored messages:', error);
    }
  }

  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Chat service error:', error);
    
    let errorMessage = 'An error occurred while processing your request.';
    
    if (error.error?.error) {
      errorMessage = error.error.error;
    } else if (error.status === 0) {
      errorMessage = 'Unable to connect to the server. Please check your connection.';
    } else if (error.status >= 500) {
      errorMessage = 'Server error. Please try again later.';
    }

    this.setTyping(false);
    return throwError(() => new Error(errorMessage));
  }

  getCurrentSessionId(): string {
    return this.sessionId;
  }

  getAvailableIntents(): Observable<{intents: string[]}> {
    return this.http.get<{intents: string[]}>(`${this.restApiURL}/intents`)
      .pipe(
        catchError(this.handleError.bind(this))
      );
  }
}